import { HOST_APP } from 'config';
import { $api } from '../axios';
import type { ParamsStoryForForm, Story, StoryList, StoryListParams } from 'types/story';

const getStoryList = (params: StoryListParams) =>
  $api.get<StoryList>(HOST_APP + 'stories', { params });

const getStory = (id: number) => $api.get<{ data: Story }>(HOST_APP + 'stories/' + id);

const editStory = ({ id, ...params }: Story) =>
  $api.put(HOST_APP + 'stories/' + id, {
    ...params,
  });

const createStory = (params: ParamsStoryForForm) => $api.post(HOST_APP + 'stories', params);

export const StoryServices = { getStory, getStoryList, editStory, createStory };
